'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import t from "../../external/react-modal/lib/index.js";
import { FontAwesomeIcon as h } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faClose as x } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import f from "./MessageView.js";
import j from "./MessageInputField.js";
import { getFullName as u } from "../../helpers/doctorUtils.js";
import e from "./chat.module.scss.js";
t.setAppElement("body");
const F = ({
  messages: a,
  onSendMessage: l,
  onModalClose: o,
  hasMoreMessages: i,
  onEndReached: m,
  open: n,
  identity: c,
  doctor: r
}) => {
  const d = () => {
    o && o(!1);
  }, p = u(r);
  return /* @__PURE__ */ s.jsxs(
    t,
    {
      id: "chat-modal",
      isOpen: n,
      onAfterClose: () => o(!0),
      className: e.window,
      overlayClassName: e.overlay,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: e.header, children: [
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("h5", { children: p }),
            /* @__PURE__ */ s.jsx("small", { children: "Usually responds within 24 hours" })
          ] }),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              "aria-label": "close",
              onClick: d,
              className: e.close,
              children: /* @__PURE__ */ s.jsx(h, { icon: x })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: e.content, children: [
          /* @__PURE__ */ s.jsx(
            f,
            {
              messages: a,
              identity: c,
              doctor: r,
              hasMoreMessages: i,
              onEndReached: m
            }
          ),
          /* @__PURE__ */ s.jsx(j, { onSubmit: l })
        ] })
      ]
    }
  );
};
export {
  F as default
};
